import React from 'react'

import { GenericAnalyticsClient, withAnalyticsClient } from '@acorns/web-utils'
import { omit } from 'ramda'
import { compose, defaultProps, mapProps, withHandlers } from 'recompose'

import defaults from './defaults'
import withFields from './withFields'

type Props = {
  className?: string
  defaultFields?: object
  fields: object
  onClick?: (event: any) => void
  onPress?: (event: any) => void
}

type Handlers = {
  trackClick: (event?: React.SyntheticEvent) => void
}

type AddedProps = Handlers & {
  analytics: GenericAnalyticsClient
}

export type TrackClickProps = Props & AddedProps

const enhance = compose<TrackClickProps, Props>(
  withAnalyticsClient,
  defaultProps({
    defaultFields: defaults('Button Tapped'),
    fields: {},
  }),

  withHandlers<TrackClickProps, Handlers>({
    trackClick:
      ({ analytics, defaultFields, fields, onClick, onPress }) =>
      (event) => {
        if (onClick) {
          onClick(event)
        } else if (onPress) {
          onPress(event)
        }

        if (Object.keys(fields).length > 0) {
          analytics.track('Button Tapped', {
            ...defaultFields,
            ...fields,
          })
        }
      },
  }),
  mapProps((props) => omit(['ctaTitle', 'defaultFields', 'fields'], props)),
)

export const TrackClicked = enhance(({ trackClick, children, className }) => (
  <div className={className} onClick={trackClick}>
    {children}
  </div>
))

export const withTrackClickedHandler = (
  customFields: object | ((props: any) => object),
) =>
  compose<TrackClickProps, TrackClickProps>(withFields(customFields), enhance)

export const withTrackClicked = <TInner, TOuter>(customFields: object) =>
  compose<TInner, TOuter>(
    withFields(customFields),
    enhance,
    (WrappedComponent: any) =>
      ({ trackClick, ...props }: TrackClickProps) => (
        <WrappedComponent {...props} onClick={trackClick} />
      ),
  )
